import uuidv4 from "uuid/v4"

export default {
  namespaced: true,

  state: {
    name: "",
    email: "",
    localStorageId: "",
    colorCode: "1",
    permissionToView: false,
    loggedIn: false
  },

  mutations: {
    setName(state, payload) {
      state.name = payload
    },
    setEmail(state, payload) {
      state.email = payload
    },
    setPermissionToView(state, payload) {
      state.permissionToView = payload
    },
    setLocalStorageId(state, payload) {
      state.localStorageId = payload
    },
    setColorCode(state, payload) {
      state.colorCode = payload
    },
    setLogin(state, payload) {
      state.loggedIn = payload
    }
  },
  actions: {
    setLocalStorageId({ commit }, localStorageId) {
      commit('setLocalStorageId', localStorageId)
    },

    setColor({ commit }, color) {
      commit('setColorCode', color)
    },

    setIdentityFromFirebase({commit}, [name, email, colorCode]) {
      commit('setName', name);
      commit('setEmail', email);
      commit('setColorCode', colorCode);
    },

    setIdentity({ commit, dispatch, state }, [name, email]) {
      commit("setName", name)
      commit("setEmail", email)
      dispatch('chatStore/sendUser', [name, email, state.localStorageId], {root: true})
    },

    getLocalStorageId({ dispatch }) {
      let bleachChatId = localStorage.getItem("bleach__chatId")
      if (bleachChatId == undefined) {
        bleachChatId = uuidv4()
        localStorage.setItem("bleach__chatId", bleachChatId)
      }

      dispatch("setLocalStorageId", bleachChatId)
    },

    login({ commit, dispatch }, [name, password]) {
      if (name.length > 1 && password.length > 1) {
        commit('setName', `Bleach: ${name}`)
        commit('setLogin', true)
        dispatch("partyStore/getAllParties", undefined, {root: true})
      }
    },

    permitEntry({ commit }) {
      commit("setPermissionToView", true)
    }
  }
}
